import {
  Shield, BookOpen, FileText, Code2, Mail, Building, Zap, MapPin, ShieldCheck, LifeBuoy, Globe, Layers, Newspaper, Scale
} from 'lucide-react';

export const resourcesGroups = [
  {
    heading: 'Learn',
    items: [
      { name: 'Insights', href: '/insights', icon: Newspaper, desc: 'The African Cloud Briefing — articles & analysis' },
      { name: 'Resource Library', href: '/resources', icon: FileText, desc: 'Guides, whitepapers & articles' },
      { name: 'Cloud by Country', href: '/cloud', icon: MapPin, desc: 'Sovereign cloud, market by market' },
      { name: 'Compare Clouds', href: '/compare', icon: Scale, desc: 'DAAKYI vs AWS, Azure & more — honestly' }
    ]
  },
  {
    heading: 'Build & Operate',
    items: [
      { name: 'Documentation', href: '/docs/getting-started/introduction', icon: BookOpen, desc: 'Guides & technical documentation' },
      { name: 'Developer Hub', href: '/developers', icon: Code2, desc: 'APIs, automation & quickstart' },
      { name: 'Support & Status', href: '/support', icon: LifeBuoy, desc: 'Get help & check service availability' }
    ]
  },
  {
    heading: 'Trust',
    items: [
      { name: 'Trust Center & Legal', href: '/trust', icon: ShieldCheck, desc: 'Security, privacy, resilience & policies' },
      { name: 'Regions', href: '/regions', icon: Globe, desc: 'Where DAAKYI Cloud operates' }
    ]
  }
];

export const resourcesLinks = resourcesGroups.flatMap(g => g.items);

export const companyLinks = [
  { name: 'Platform', href: '/platform', icon: Layers, desc: 'How DAAKYI Cloud works' },
  { name: 'Why DAAKYI', href: '/why-daakyi', icon: Zap, desc: 'Why enterprises choose us' },
  { name: 'About Us', href: '/about', icon: Building, desc: 'Our mission & team' },
  { name: 'Security', href: '/security', icon: Shield, desc: 'Trust & infrastructure' },
  { name: 'Contact', href: '/contact', icon: Mail, desc: 'Get in touch' }
];
